var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
// semeia-disable-reexport

import { tracked } from "@glimmer/tracking";
import { practiceLocationIndex } from "cnam/cnam-adapters/utils";
import CnamServicesAccessFormAuthenticationModifyPracticeLocationComponent from "cnam/components/cnam-services-access-form/authentication/modify-practice-location";
import CnamServicesAccessFormAuthenticationSetPracticeLocationComponent from "cnam/components/cnam-services-access-form/authentication/set-practice-location";
import formatToISO8601Date from "core/utils/format-to-iso8601-date";
import { getItemFromLocalStorage, setItemInLocalStorage } from "core/utils/use-local-storage";
import CnamContext, { State } from "./abstract/cnam-context";
export let AuthenticationContext = (_class = class AuthenticationContext extends CnamContext {
  constructor(cnamAdapterName, cardReaderAdapter, medic, store, fetcher, requestManager) {
    super(store, requestManager, cnamAdapterName);
    _defineProperty(this, "cardReaderAdapter", void 0);
    _defineProperty(this, "medic", void 0);
    _defineProperty(this, "fetcher", void 0);
    _initializerDefineProperty(this, "availableLocations", _descriptor, this);
    _initializerDefineProperty(this, "practiceLocation", _descriptor2, this);
    _initializerDefineProperty(this, "cpsPracticeLocationIndice", _descriptor3, this);
    _initializerDefineProperty(this, "cpsInformations", _descriptor4, this);
    _initializerDefineProperty(this, "updatePracticeLocation", _descriptor5, this);
    _initializerDefineProperty(this, "ratesChecked", _descriptor6, this);
    _defineProperty(this, "_shouldUpdatePracticeLocation", () => {
      return !this.practiceLocation || this.updatePracticeLocation || this._getPracticeLocationIndex() < 0 // if the medic practice location is not on the CPS card any more
      ;
    });
    _defineProperty(this, "_getPracticeLocationIndex", () => {
      const availableLocations = this.cpsInformations?.practiceLocations || this.availableLocations;
      if (availableLocations) {
        return practiceLocationIndex(this.practiceLocation, availableLocations);
      }
      return -1;
    });
    _defineProperty(this, "_updateMedicWithNewPracticeLocationIfNeeded", async () => {
      if (this.medic.practiceLocation !== this.practiceLocation) {
        this.medic.practiceLocation = this.practiceLocation;
        await this.medic.save();
      }
    });
    this.cardReaderAdapter = cardReaderAdapter;
    this.medic = medic;
    this.store = store;
    this.fetcher = fetcher;
    this.states = [new State("set-practice-location", () => {
      return Promise.resolve(this.updatePracticeLocation || this._shouldUpdatePracticeLocation() || !(this.cpsPracticeLocationIndice != undefined && this.cpsPracticeLocationIndice >= 0 && Boolean(this.practiceLocation)));
    }, async () => {
      await this.updatePracticeLocationNameAndIndice();
      this.updatePracticeLocation = false;
    }, CnamServicesAccessFormAuthenticationSetPracticeLocationComponent), new State("allow-practice-location-modifications", () => {
      return Promise.resolve(this.updatePracticeLocation == undefined && Boolean(this.practiceLocation));
    }, async () => {
      return;
    }, CnamServicesAccessFormAuthenticationModifyPracticeLocationComponent), new State("check-rates", () => {
      return Promise.resolve(!this.ratesChecked && Boolean(this.cpsInformations));
    }, async () => {
      const twoDaysBefore = new Date(new Date().setDate(new Date().getDate() - 2));
      twoDaysBefore.setHours(0, 0, 0, 0);
      await this.fetcher.loadRecords("dmp-retrieval-started-journal-event", {
        filter: {
          cps_id: this.cpsInformations?.medicInternalId,
          occurred_at_gte: formatToISO8601Date(twoDaysBefore)
        }
      });
      this.ratesChecked = true;
    })];
  }
  async updatePracticeLocationNameAndIndice() {
    this.setPracticeLocationInLocalStorage(this.practiceLocation);
    await this._updateMedicWithNewPracticeLocationIfNeeded();
    this.cpsPracticeLocationIndice = this._getPracticeLocationIndex();
    this.setCpsPracticeLocationIndice(this.cpsPracticeLocationIndice);
  }
  reset() {
    super.reset();
    this.cpsPracticeLocationIndice = Number(getItemFromLocalStorage(this._cpsPracticeLocationIndiceKey()));
    const practiceLocationFromLocalStorage = getItemFromLocalStorage(this._practiceLocationKey());
    this.practiceLocation = practiceLocationFromLocalStorage == null ? undefined : practiceLocationFromLocalStorage;
    this.availableLocations = getItemFromLocalStorage(this._availableLocationsKey()) ? JSON.parse(getItemFromLocalStorage(this._availableLocationsKey())) : undefined;
    this.updatePracticeLocation = undefined;
    this.cpsInformations = undefined;
    this.ratesChecked = false;
  }
  get currentPracticeLocation() {
    return this.cpsPracticeLocationIndice != undefined && this.cpsPracticeLocationIndice >= 0 ? this.availableLocations?.[this.cpsPracticeLocationIndice] : undefined;
  }
  retrieveAdministrativeInformationFromPraticeLocation(practiceLocation) {
    return {
      billingNumber: practiceLocation?.billingNumber,
      // If the structureId is prefixed with a "1", it's a FINESS
      finess: practiceLocation?.structureId?.startsWith("1") ? practiceLocation.structureId : undefined,
      // If the structureId is prefixed with a "4", it's a SIRET
      siret: practiceLocation?.structureId?.startsWith("4") ? practiceLocation.structureId : undefined
    };
  }
  get billingNumber() {
    // If the finess is forced, we use it
    const forcedIdentifier = this.medic.forceIdentifierForInsRetrieval;
    const administrativeInfosFromCurrentPracticeLocation = this.retrieveAdministrativeInformationFromPraticeLocation(this.currentPracticeLocation);
    // If the PS is a liberal, it has a billing number
    const billingNumber = administrativeInfosFromCurrentPracticeLocation.billingNumber;
    // Otherwise, it should be a employee. Then, the FINESS or the SIRET of the structure should be stored under structureId.
    const finess = administrativeInfosFromCurrentPracticeLocation.finess;
    const siret = administrativeInfosFromCurrentPracticeLocation.siret;
    return forcedIdentifier || billingNumber || finess || siret;
  }
  get practiceLocationsWithValidBillingNumber() {
    return this.availableLocations?.filter(practiceLocation => {
      const administrativeInfos = this.retrieveAdministrativeInformationFromPraticeLocation(practiceLocation);
      return administrativeInfos.billingNumber || administrativeInfos.finess || administrativeInfos.siret;
    }) || [];
  }
  setPracticeLocationInLocalStorage(practiceLocation) {
    setItemInLocalStorage(this._practiceLocationKey(), practiceLocation);
  }
  setCpsPracticeLocationIndice(cpsPracticeLocationIndice) {
    setItemInLocalStorage(this._cpsPracticeLocationIndiceKey(), cpsPracticeLocationIndice.toString());
  }
  _practiceLocationKey() {
    return "authentication:practice-location";
  }
  _availableLocationsKey() {
    return "authentication:available-locations";
  }
  _cpsPracticeLocationIndiceKey() {
    return "authentication:cps-practice-location-indice";
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "availableLocations", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "practiceLocation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cpsPracticeLocationIndice", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "cpsInformations", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "updatePracticeLocation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "ratesChecked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);